import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  labelBox: {
    fontFamily: "Eurostile !important",
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    // border: "2px solid #dbdbdb",
    marginTop: "16px !important",
    // background: "#eeecef",
    // paddingTop:'7px !important',
    paddingBottom: "6px",
    paddingLeft: "8px !important",
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px",
    height: "36px",
    fontSize:'18px !important',
    color:'#333333',
    fontWeight:600
  },
  popupTitle: {
    position: "fixed",
    borderBottom: "1px solid #CCC",
    left: 100,
    top: 80,
    right: 100,
    background: "#FFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0px 20px",
    border: "2px solid #CCC",
    borderTopRightRadius: "5px",
    borderTopLeftRadius: "5px",
    zIndex: 1,
    "& h6": {
      padding: "0px",
      fontWeight: "600!important" as any,
    },
  },
     estimatePopupOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.7)", // 👈 semi-transparent dark background
    zIndex: 999, // keep above everything
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  estimatePopupContainer: {
   position: "fixed",
    background: "#fff",
    left: 100,
    top: 80,
    right: 100,
    bottom: 48,
    padding: "20px 20px 80px",
    overflow: "auto",
    borderRadius: "5px",
    border: "2px solid #CCC",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    borderTopRightRadius: "5px",
    borderTopLeftRadius: "5px",
},
  gridDetails: {
    textAlign: "center",
    padding: "4px",
    border: "0px",
    background: "#fafafa",
    fontWeight: 500,
    fontSize: "14px",
  },
  gridLabelDetails: {
    textAlign: "center",
    padding: "4px",
    border: "0px",
    background: "#fafafa",
    fontWeight: 500,
    fontSize: "14px",
    fontFamily: 'Eurostile !important',
  },
});

export default useStyles;
